import { useState } from 'react';
import { breakingNews, categories } from '@/mocks/homeMock';

export default function Breaking() {
  const [active, setActive] = useState('全部');

  const tags = ['全部', ...categories];
  const filtered = active === '全部' ? breakingNews : breakingNews.filter((n) => n.tag === active);
  const isFiltered = active !== '全部';

  const list = isFiltered && filtered.length === 0 ? breakingNews : filtered;

  return (
    <section id="breaking" className="scroll-mt-20 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-flashlight-line" />
              BREAKING
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">抢先首发快讯</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">从路透到实锤，我们第一时间锁定首发窗口并完成梳理。</p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {tags.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition ${
                active === t
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-background-200'
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((n) => (
            <article key={n.id} className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:shadow-[0_16px_40px_-24px_rgba(0,0,0,0.28)]">
              <div className="relative h-40 overflow-hidden">
                <img src={n.img} alt={n.title} className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  <i className="ri-flashlight-fill" />
                  {n.tag}
                </span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-semibold text-background-50 backdrop-blur">
                  <i className="ri-fire-fill text-accent-400" />
                  {n.hot}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-900 group-hover:text-primary-600 md:text-base">
                  {n.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600 md:text-sm">{n.excerpt}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line text-accent-600" />
                    {n.ago}
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600">
                    <i className="ri-signal-tower-line" />
                    {n.firstSource}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {isFiltered && (
          <p className="mt-6 text-center text-sm text-foreground-500">
            当前分类暂无首发快讯，已为你展示全部实时内容。
          </p>
        )}
      </div>
    </section>
  );
}